import './plugins/polyfills'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './validation'
import { sync } from 'vuex-router-sync'

import VueAbsolutePath from './plugins/VueAbsolutePath'
import VueAnimateOnIntersection from './plugins/VueAnimateOnIntersection'
import './plugins/Viewports'
import 'normalize.css'
import './plugins/Raven'
import VueApollo from 'vue-apollo'
import apolloClient from './apollo'
import VueMeta from 'vue-meta'
// import './plugins/Raven'

sync(store, router)
Vue.use(VueAbsolutePath, { remote: process.env.VUE_APP_ENDPOINT })
Vue.use(VueAnimateOnIntersection)
Vue.use(VueApollo)
Vue.use(VueMeta)

Vue.config.productionTip = false

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

new Vue({
  router,
  store,
  i18n,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
